// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__CT_17nrhE3{width:640px}.helpTooltip__sHeChoOFyb{width:260px}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/analytics/components/quickView/components/modal/quickViewModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA,CAGF,yBACE,WAAA","sourcesContent":[".modal {\n  width: 640px;\n}\n\n.helpTooltip {\n  width: 260px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__CT_17nrhE3`,
	"helpTooltip": `helpTooltip__sHeChoOFyb`
};
export default ___CSS_LOADER_EXPORT___;
